import PropTypes from 'prop-types'
import React from 'react'
import {
  ADDITIONAL_RELATED_SECTIONS,
  ADDITIONAL_RELATED_SECTIONS_SWAPPED,
} from 'components/pdp/const'
import { customFlagValue, isFlagEligible } from 'lib/utils/handle-flag/const'
import { withI18next } from 'lib/i18n/withI18next'
import DynamicSection from '../dynamic-section'
import InfiniteSection from '../infinite-section'

const RelatedProductSection = ({ product }) => {
  const justForYouPosSwapFlagValue = customFlagValue({ defaultValue: 'OFF' }) // TODO: force flag value to handle with flagsmith later ('PDPUpsellPosition-20221114' old flag name)
  const shouldSwapJustForYouSection = isFlagEligible(justForYouPosSwapFlagValue)
  const sectionGuideList = shouldSwapJustForYouSection
    ? ADDITIONAL_RELATED_SECTIONS_SWAPPED
    : ADDITIONAL_RELATED_SECTIONS

  return (
    <div className="pdp__related-products__container">
      {sectionGuideList.map((type, idx) => (
        <DynamicSection
          key={type}
          feedPos={idx + 2}
          product={product}
          sectionType={type}
        />
      ))}
      {shouldSwapJustForYouSection && <InfiniteSection product={product} />}
    </div>
  )
}

RelatedProductSection.propTypes = {
  product: PropTypes.shape({
    id_product: PropTypes.number,
  }).isRequired,
}

export default withI18next()(RelatedProductSection)
